import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as TransactionActions from '../../redux/actions/transactionAction.js';
import MainDatatable from "../../components/common/MainDatatable.jsx";
import { ViewSvg } from "../../assets/svg/index.js";
import { DayMonthYearWithTime } from "../../utils/common-function/index.js";
import PaginationDatatable from "../../components/common/PaginationDatatable.jsx";
import { Button, Icon, TextField } from "@mui/material";
import { CSVLink } from "react-csv";

const DisplayTransaction = () => {

    const currentDate = new Date()
    console.log({ currentDate: currentDate.toISOString().substring(0, 10) });
    const [selectDate, setSelectDate] = useState(currentDate.toISOString().substring(0, 10))
    const [phone, setPhone] = useState('')
    const [payType, setPaytype] = useState('')
    const [rows, setRows] = useState('10')
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { transactionHistoryData } = useSelector(state => state.transactionReducer)
    const { data: transactionHistory, pagination } = transactionHistoryData;
    console.log({ payType });

    //* Transaction DataTable Columns
    const transactionColumns = [
        { name: "S.No.", selector: (row) => (currentPage - 1) * 5 + transactionHistory?.indexOf(row) + 1, style: { backGroundColor: "#000", paddingLeft: "20px" } },
        { name: 'Transaction Id', selector: row => row?.operatorData?.data?.ApiTransID, width: "350px" },
        { name: 'Tran.Amount', selector: row => row?.amount },
        { name: 'Transaction Type', selector: row => row?.billType },
        { name: 'Payment Mode', selector: row => 'Razor Pay' },
        { name: 'Payment Status', selector: row => row?.transactionalData?.status_code === 200 ? <div style={{ color: "green" }}>Done</div> : <div style={{ color: "red" }}>Failure</div> },
        { name: 'Date', selector: row => DayMonthYearWithTime(row?.createdAt), width: "200px" },
        {
            name: 'Action',
            cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
                <div onClick={() =>navigate(`/transaction/details/?transactionid=${row?._id}`)} style={{ cursor: "pointer" }}><ViewSvg /></div>
            </div >
        },

    ];

    const [currentPage, setCurrentPage] = useState(Number(localStorage.getItem('current-page')));

    const handlePageChange = (page) => {
        localStorage.setItem('current-page', page)
        setCurrentPage(page)
    };
    const handleNextPageChange = (page) => {
        console.log(currentPage, page)
        localStorage.setItem('current-page', Number(currentPage) + Number(page))
        setCurrentPage(currentPage + page)
    };
    const handlePrevPageChange = (page) => {
        localStorage.setItem('current-page', currentPage - page)
        setCurrentPage(currentPage - page)
    };

    useEffect(() => {
        localStorage.setItem('current-page', 1)
    }, []);

    useEffect(() => {
        localStorage.setItem('current-page', 1)

        //! Dispatching API for Getting Tran.History
        dispatch(TransactionActions.getTransactionHistory({ date: selectDate, phone: phone, page: currentPage, limit: rows, paymentkey: payType }))
    }, [currentPage, selectDate, phone.length === 10, payType, rows]);
    // Recharge || Electricity || Fastag || DTH | GAS CYLINDER || Hotel || Flight
    return (
        <>
            <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
                <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>Transaction</div>

                <div className="row">
                    <div className="col-lg-3">
                        <input type="date" className="form-control" value={selectDate} onChange={(e) => setSelectDate(e.target.value)} />
                    </div>
                    <div className="col-lg-3">
                        <input type="text" className="form-control" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Search By Phone 9587...." />
                    </div>
                    <div className="col-lg-3">
                        <select className="form-select" onChange={(e) => setPaytype(e.target.value)}>
                            <option>Choose Payee Type</option>
                            <option value="Recharge">Recharge</option>
                            <option value="Electricity">Electricity</option>
                            <option value="Fastag">Fastag</option>
                            <option value="DTH">DTH</option>
                            <option value="GAS CYLINDER">GAS CYLINDER</option>
                            <option value="Hotel">Hotel</option>
                            <option value="Flight">Flight</option>

                        </select>
                    </div>
                    <div className="col-lg-3">
                        <select className="form-select" onChange={(e) => setRows(e.target.value)}>

                            <option value="10">10 Rows</option>
                            <option value="20">20 Rows</option>
                            <option value="30">30 Rows</option>
                            <option value="50">50 Rows</option>
                            <option value="100">100 Rows</option>

                        </select>
                    </div>
                </div>


                <PaginationDatatable data={transactionHistory} columns={transactionColumns} currentPage={currentPage} handlePageChange={handlePageChange} handleNextPageChange={handleNextPageChange} handlePrevPageChange={handlePrevPageChange} paginationData={pagination} />
            </div>
        </ >
    );
}

export default DisplayTransaction;